import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { LocalStorageService } from '@core/services/local-storage.service';
import { LoaderComponent } from "@shared/components/loader.component";
import { MetricsService } from '@core/services/metrics.service';

import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-root',

  imports: [RouterOutlet, LoaderComponent],
  standalone: true,
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  private readonly translocoService = inject(TranslocoService);
  private readonly localStorage = inject(LocalStorageService);
  private readonly metrics = inject(MetricsService);

  private readonly languageStorageKey = 'app.lang';

  protected readonly title = signal('app-willay-ai');

  ngOnInit(): void {
    this.metrics.initialize();

    const storedLang = this.localStorage.get<string>(this.languageStorageKey);
    if (!storedLang) {
      return;
    }

    const available = this.translocoService.getAvailableLangs();
    const availableIds = Array.isArray(available)
      ? available.map((lang) => (typeof lang === 'string' ? lang : lang.id))
      : [];

    if (availableIds.includes(storedLang)) {
      this.translocoService.setActiveLang(storedLang);
    }
  }
}
